import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowUpRight } from "lucide-react";
import { BUSINESS, NAV_LINKS } from "../data/content";

export const Footer = () => (
  <footer data-testid="main-footer" className="relative overflow-hidden bg-ink text-white">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="border-b border-white/10 py-16 sm:py-24">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-brand">
          {BUSINESS.motto}
        </p>
        <h2 className="mt-6 max-w-4xl font-display text-4xl font-extrabold leading-[0.95] tracking-tight sm:text-6xl lg:text-7xl">
          Let's build something that <span className="text-brand">wins.</span>
        </h2>
        <div className="mt-10 flex flex-col gap-4 sm:flex-row">
          <Link
            to="/contact"
            data-testid="footer-quote-btn"
            className="group inline-flex items-center justify-center gap-2 rounded-full bg-brand px-7 py-4 font-bold text-ink transition-transform duration-300 hover:-translate-y-0.5 hover:bg-brand-dark hover:text-white"
          >
            Request a Free Quote
            <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
          <a
            href={BUSINESS.phoneHref}
            className="inline-flex items-center justify-center gap-2 rounded-full border border-white/20 px-7 py-4 font-bold transition-colors hover:bg-white/5"
          >
            <Phone className="h-4 w-4" /> {BUSINESS.phone}
          </a>
        </div>
      </div>

      <div className="grid gap-12 py-16 md:grid-cols-4">
        <div className="md:col-span-2">
          <span className="font-display text-2xl font-extrabold">{BUSINESS.name}</span>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-white/60">
            {BUSINESS.mission}
          </p>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-white/40">Explore</p>
          <ul className="mt-5 space-y-3">
            {[{ label: "Home", to: "/" }, ...NAV_LINKS, { label: "Contact", to: "/contact" }].map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  className="text-sm text-white/70 transition-colors hover:text-white"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-white/40">Get in touch</p>
          <ul className="mt-5 space-y-4 text-sm">
            <li>
              <a href={BUSINESS.phoneHref} className="flex items-center gap-3 text-white/70 hover:text-white">
                <Phone className="h-4 w-4 text-brand" /> {BUSINESS.phone}
              </a>
            </li>
            <li>
              <a href={BUSINESS.emailHref} className="flex items-center gap-3 text-white/70 hover:text-white">
                <Mail className="h-4 w-4 text-brand" /> {BUSINESS.email}
              </a>
            </li>
            <li className="flex items-center gap-3 text-white/70">
              <MapPin className="h-4 w-4 text-brand" /> {BUSINESS.location}
            </li>
          </ul>
        </div>
      </div>

      <div className="flex flex-col items-start justify-between gap-3 border-t border-white/10 py-8 text-xs text-white/40 sm:flex-row sm:items-center">
        <span>© {new Date().getFullYear()} {BUSINESS.name}. All rights reserved.</span>
        <span className="font-mono uppercase tracking-[0.2em]">Owner · {BUSINESS.owner}</span>
      </div>
    </div>
  </footer>
);
